import {
  InternalServerError,
  wrapErrorAsColumnError
} from '../errors/ColumnErrors';
import { CollectionKey, SnapshotModel } from '.';
import { ColumnService } from '../services/directory';
import { ResponseOrColumnError, wrapSuccess } from '../types/responses';
import { getErrorReporter } from '../utils/errors';
import { TimestampedModel } from './types';
import { EPartialDocumentData, ETransaction } from '../types';

export async function safeUpdateModel<
  E extends TimestampedModel,
  C extends CollectionKey
>(
  model: SnapshotModel<E, C>,
  updateData: EPartialDocumentData<E>,
  options: { transaction?: ETransaction } = {}
): Promise<ResponseOrColumnError<void>> {
  const { transaction } = options;
  try {
    if (transaction) {
      // Need to do this because the ref.proxy doesn't get called when updating via a transaction :(
      const dataWithModifiedAt: EPartialDocumentData<E> = {
        ...updateData,
        modifiedAt: model.getTimestamp()
      };
      transaction.update(model.ref, dataWithModifiedAt);
    } else {
      await model.ref.update(updateData);
    }
    return wrapSuccess(undefined);
  } catch (e) {
    getErrorReporter().logAndCaptureError(
      ColumnService.DATABASE,
      e,
      'Failed to update model',
      {
        id: model?.id ?? 'null',
        type: model?.type ?? 'null'
      }
    );
    return wrapErrorAsColumnError(e as Error, InternalServerError);
  }
}
